var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.25,
    stroke: "#444C5E",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83333 18.2143L12 13.5M21.1667 18.2143L17 13.5M7 10.3571L13.0208 14.1416C13.5554 14.4777 13.8227 14.6457 14.1116 14.7109C14.3669 14.7687 14.6331 14.7687 14.8884 14.7109C15.1773 14.6457 15.4446 14.4777 15.9792 14.1416L22 10.3571M9.66667 19H19.3333C20.2667 19 20.7335 19 21.09 18.8287C21.4036 18.6781 21.6586 18.4377 21.8183 18.142C22 17.8059 22 17.3658 22 16.4857V10.5143C22 9.63421 22 9.19416 21.8183 8.85802C21.6586 8.56233 21.4036 8.32193 21.09 8.17128C20.7335 8 20.2667 8 19.3333 8H9.66667C8.73325 8 8.26653 8 7.91002 8.17128C7.59641 8.32193 7.34144 8.56233 7.18166 8.85802C7 9.19416 7 9.6342 7 10.5143V16.4857C7 17.3658 7 17.8059 7.18166 18.142C7.34144 18.4377 7.59641 18.6781 7.91002 18.8287C8.26653 19 8.73324 19 9.66667 19Z",
    stroke: "#444C5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.9b24a8876c74a21a300d05fc2f7fc225.svg";
export { ForwardRef as ReactComponent };